import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const normalizeTeamRole = (value) => {
  const role = String(value || '').toLowerCase();
  if (role === 'coach' || role === 'analyst' || role === 'assistant_coach' || role === 'player') {
    return role;
  }
  return 'player';
};

// Handles profile load/save and core identity fields
export const useProfileSettings = (auth, db) => {
  const [profile, setProfile] = useState(null);
  const [teamId, setTeamId] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [ign, setIgn] = useState('');
  const [role, setRole] = useState('player');
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState('');

  // Load profile once on auth change
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      const userRef = doc(db, `users/${user.uid}`);
      const snap = await getDoc(userRef);
      if (snap.exists()) {
        const data = snap.data();
        setProfile(data);
        setTeamId(data.teamId || '');
        setBirthdate(data.birthdate || '');
        setFirstName(data.firstName || '');
        setLastName(data.lastName || '');
        setIgn(data.ign || '');
        setRole(normalizeTeamRole(data.role));
      }
    });
    return () => unsub();
  }, [auth, db]);

  const saveProfile = async (e) => {
    e.preventDefault();
    const user = auth?.currentUser;
    if (!user) return;
    setSaving(true);
    setStatus('');
    try {
      const userRef = doc(db, `users/${user.uid}`);
      await setDoc(
        userRef,
        { teamId: teamId || '', birthdate, firstName, lastName, ign, role: normalizeTeamRole(role) },
        { merge: true }
      );
      setStatus('Saved successfully.');
      setProfile((prev) => ({ ...(prev || {}), teamId, birthdate, firstName, lastName, ign, role }));
    } catch (err) {
      console.error('Failed to save profile', err);
      setStatus('Failed to save.');
    } finally {
      setSaving(false);
    }
  };

  return {
    profile,
    teamId,
    setTeamId,
    birthdate,
    setBirthdate,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    ign,
    setIgn,
    role,
    setRole,
    saving,
    status,
    setStatus,
    saveProfile,
  };
};

export default useProfileSettings;
